import React from 'react';
import { motion } from 'framer-motion';
import { HeartIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { heroQuotes } from '../data/content';
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 16
  },
  show: {
    opacity: 1,
    y: 0
  }
};
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <header className="w-full bg-cream-50 px-5 pb-14 pt-5 sm:pb-16 sm:pt-16" data-id="element-93" data-mp="4n1j0kwg00pc">
      <motion.div initial="hidden" animate="show" transition={{
      staggerChildren: 0.05
    }} className="mx-auto max-w-content text-center" data-id="element-94" data-mp="129qvxpsonxpz">
        <motion.p variants={fadeUp} transition={{
        duration: 0.28,
        ease
      }} className="mx-auto inline-flex items-center gap-2 rounded-full border border-rose-200 bg-rose-50 px-3.5 py-1.5 text-[10px] font-semibold uppercase tracking-[0.2em] text-rose-600 sm:px-4 sm:py-2 sm:text-[11px] sm:tracking-[0.22em]" data-id="element-95" data-mp="sb1chsl5257m">
          <HeartIcon aria-hidden="true" className="h-3 w-3 fill-rose-400 text-rose-400 sm:h-3.5 sm:w-3.5" data-id="element-96" data-mp="380vy3velgpc3" />
          Sistema Después de Él
        </motion.p>

        <motion.h1 variants={fadeUp} transition={{
        duration: 0.32,
        ease
      }} className="mx-auto mt-4 max-w-4xl font-display text-[1.6rem] font-semibold leading-[1.12] tracking-tight text-plum-800 sm:mt-8 sm:text-5xl sm:leading-[1.05] lg:text-6xl" data-id="element-97" data-mp="3o85b7b3xi14k">
          No quieres más promesas ni más intentos. Solo quieres que esta relación termine.{' '}
          <span className="italic text-rose-500" data-id="element-98" data-mp="358reiletecad">
            Este sistema es el plan que te faltaba para lograrlo.
          </span>
        </motion.h1>

        <motion.div variants={fadeUp} transition={{
        duration: 0.36,
        ease
      }} className="mt-4 sm:mt-10" data-id="element-99" data-mp="2ql6e4z9bqr65">
          <img src="https://cdn.magicpatterns.com/uploads/dGssru8K6afc5rFUK5yURT/ChatGPT_Image_13_ago_2026,_19_49_18.png" alt="Los 6 volúmenes del Sistema Después de Él" className="mx-auto max-h-[26vh] w-full max-w-2xl object-contain mix-blend-multiply sm:max-h-none" data-id="element-100" data-mp="2hj5e5umphr0s" />
        </motion.div>

        <motion.p variants={fadeUp} transition={{
        duration: 0.32,
        ease
      }} className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-plum-500 sm:mt-8 sm:text-lg" data-id="element-101" data-mp="naa12rwhfkmi">
          El método completo para salir de una relación que te destruye por dentro, romper el
          vínculo que no te deja soltar y construir la vida que siempre mereciste.
        </motion.p>

        <motion.div variants={fadeUp} transition={{
        duration: 0.32,
        ease
      }} className="mt-5 flex flex-col items-center gap-3 sm:mt-8 sm:gap-4" data-id="element-102" data-mp="162ugb6j9dr7u">
          <CtaButton className="w-full max-w-sm sm:w-auto" data-id="element-103" data-mp="x1ny8t0yo8ch">
            Quiero empezar mi proceso ahora
          </CtaButton>
          <p className="text-xs text-plum-400 sm:text-sm" data-id="element-104" data-mp="3ltqclcptivti">
            6 Volúmenes + 5 Bonos · Acceso inmediato
          </p>
        </motion.div>
      </motion.div>

      <div className="mx-auto mt-12 grid max-w-content gap-x-10 gap-y-8 sm:mt-14 sm:grid-cols-3" data-id="element-105" data-mp="1x9um0eak5jp0">
        {heroQuotes.map(item => <figure key={item.author} className="flex h-full flex-col border-t border-rose-200 pt-5" data-id="element-106" data-mp="21bfuzojz1dtx">
            <blockquote className="font-display text-xl italic leading-snug text-plum-700" data-id="element-107" data-mp="268g282sk4mmm">
              “{item.quote}”
            </blockquote>
            <figcaption className="mt-auto pt-4 text-xs font-semibold uppercase tracking-[0.16em] text-rose-500" data-id="element-108" data-mp="2fzsqylj26wof">
              {item.author} — {item.place}
            </figcaption>
          </figure>)}
      </div>
    </header>;
}